import { createFileRoute } from "@tanstack/react-router";
import ServicesHub from "@/pages/ServicesHub";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/services/")({
  head: () =>
    buildHead({
      title:
        "Pool Remodeling, Pavers & Outdoor Services | Precision Pavers & Pool Design | Broward County, FL",
      description:
        "Expert pool remodeling, pool deck resurfacing, driveway and patio pavers, artificial turf, outdoor lighting, water features, and more. Precision Pavers & Pool Design serves Fort Lauderdale, Coral Springs, Weston, and all of Broward County. Free estimates.",
      path: "/services",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://precisionpaverspools.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Services",
            item: "https://precisionpaverspools.com/services",
          },
        ],
      },
    }),
  component: ServicesHub,
});
